var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useCallback } from 'react';
import { useQuery, useLazyQuery } from '@apollo/client';
import useDebouncedFunction from 'utils/hooks/useDebouncedFunction';
import { compose, filter, map, pathOr, prepend } from 'ramda';
import { cursorFetchMore, getNodes, getPageInfo } from 'utils/paginationHelper';
import { NODES_PATH } from 'constants/dataPaths';
import MEMBERS_FOR_SELECT from 'apollo/queries/MEMBERS_FOR_SELECT';
import MEMBER_BY_ID from 'apollo/queries/MEMBER_BY_ID';
import Member from 'model/person/member';
export var DEFAULT_MEMBER_FILTERS = {
    only_registered: false
};
var getMemberOptions = function (_a) {
    var membersData = _a.membersData, memberData = _a.memberData;
    var memberOptions = compose(map(function (item) { return new Member(item).getSelectOption; }), getNodes(['members']))(membersData);
    if (memberData) {
        var member_1 = new Member(pathOr(null, ['member'], memberData));
        return compose(prepend(member_1.getSelectOption), filter(function (item) { return item.id !== member_1.id; }))(memberOptions);
    }
    return memberOptions;
};
var useMemberSelect = function (_a) {
    var memberId = _a.memberId, variables = _a.variables;
    var _b = useLazyQuery(MEMBERS_FOR_SELECT), loadMembers = _b[0], _c = _b[1], membersLoading = _c.loading, membersData = _c.data, fetchMore = _c.fetchMore;
    var _d = useQuery(MEMBER_BY_ID, {
        variables: { id: memberId },
        skip: !memberId
    }), memberLoading = _d.loading, memberData = _d.data;
    var doSearch = useCallback(function (search) {
        if (!search)
            return false;
        return loadMembers({
            variables: {
                filters: __assign(__assign({ search: search }, DEFAULT_MEMBER_FILTERS), variables)
            }
        });
    }, [loadMembers, variables]);
    var debouncedSearch = useDebouncedFunction(doSearch, 500);
    var onPopupScroll = function (event) {
        var target = event.target;
        if (target.scrollTop +
            target.offsetHeight ===
            target.scrollHeight) {
            var pageInfo = getPageInfo(['members'])(membersData);
            if (!pageInfo.hasNextPage)
                return;
            cursorFetchMore(fetchMore)({
                dataPath: ['members'],
                dataType: NODES_PATH,
                pageInfo: pageInfo
            });
        }
    };
    var memberOptions = getMemberOptions({
        membersData: membersData,
        memberData: memberData
    });
    return {
        functions: {
            debouncedSearch: debouncedSearch,
            onPopupScroll: onPopupScroll
        },
        data: {
            memberOptions: memberOptions,
            loading: memberLoading || membersLoading
        }
    };
};
export default useMemberSelect;
